import { z } from 'zod';
// =============================================================================
// Onboarding session: a member's chat-led setup in their first conversation
// =============================================================================
/**
 * Every setup step Bill can raise. This is the vocabulary only: which steps a member gets, and in
 * what order, is the registry in `onboarding-session.steps.ts`. Keys are stored as text and are
 * permanent ids, never renamed.
 */
export const ONBOARDING_STEP_KEYS = ['hourlyRate', 'whatsapp', 'email', 'calendar', 'firstClient', 'firstTimeEntry', 'logo'];
export const OnboardingStepKeySchema = z.enum(ONBOARDING_STEP_KEYS);
/**
 * `done` is derived from account facts on every read and never asserted by the model.
 * `skipped` ("not now") and `declined` ("I don't want this") are what the user said; neither is
 * raised again in the session.
 */
export const OnboardingStepStateSchema = z.enum(['pending', 'done', 'skipped', 'declined']);
/** How hard the next reply steers back to the nominated step. */
export const OnboardingNudgeSchema = z.enum(['move-on', 'soft', 'firm']);
export const OnboardingChecklistSchema = z.object({
    /** The steps that apply to this member, in nomination order. */
    steps: z.array(z.object({ key: OnboardingStepKeySchema, state: OnboardingStepStateSchema })),
    /** The first pending step, or null when nothing is left. */
    nominated: OnboardingStepKeySchema.nullable(),
    /** Null when nothing is left to nominate. */
    nudge: OnboardingNudgeSchema.nullable(),
    /** User turns since a step last moved. */
    turnsSinceProgress: z.number().int().nonnegative(),
});
export const OnboardingSessionResponseSchema = z.object({
    sessionId: z.string().uuid(),
    conversationId: z.string().uuid(),
    checklist: OnboardingChecklistSchema,
});
